<template>
    <div class="module-wrap module-all-time" >
      <!--:allTimeData="allTimeData"-->
      <h2 v-html="moduleTitle" style="margin-top: 0!important;"></h2>
      <div class="time-wrap">
        <div class="my-time">
          <h4>我的用时</h4>
          <div class="pie my-pie">
            <el-progress :show-text="false" type="circle" v-if="isShowData" :percentage="myTime"
             >
            </el-progress>
            <div class="showTime">
              {{showMyTime}}
            </div>
          </div>
        </div>
        <img src="@/assets/img/vs.png"/>
        <div class="all-time">
          <h4>全国平均用时</h4>
          <div class="pie state-pie">
            <el-progress :show-text="false" type="circle" v-if="isShowData"
             :percentage="qgTime"
             color="#FF9A42" ></el-progress>
            <div class="showTime">
               {{showQgTime}}
             </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */
import { getPercentTime } from '@/pages/dl-web/utils/index';

export default {
  name: 'ModuleAllTime',
  // props: ['moduleTitle', 'allTimeData'],
  props: {
    moduleTitle: {
      type: String,
    },
    allTimeData: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  percentage: '',
  data() {
    return {
      timeData: {},
      total_time: null,
      advise_time: null,
      average_time: null,
      isShowData: false,
    };
  },
  watch: {
    // allTimeData (val) {
    //   this.$emit('update:allTimeData', val)
    //   // this.initData()
    // }
  },
  computed: {
    myTime() {
      // return this.formatHMStoS(this.allTimeData.total_time)/this.formatHMStoS(this.allTimeData.advise_time)*100
      return this.formatHMStoS(this.timeData.total_time) / this.formatHMStoS(this.timeData.advise_time) * 100 > 100 ? 100 : this.formatHMStoS(this.timeData.total_time) / this.formatHMStoS(this.timeData.advise_time) * 100;
    },
    qgTime() {
      return this.formatHMStoS(this.timeData.average_time) / this.formatHMStoS(this.timeData.advise_time) * 100 > 100 ? 100 : this.formatHMStoS(this.timeData.average_time) / this.formatHMStoS(this.timeData.advise_time) * 100;
    },
    showMyTime() {
      return this.formatHMStoS(this.timeData.total_time, true);
    },
    showQgTime() {
      return this.formatHMStoS(this.timeData.average_time, true);
    },
  },
  mounted() {
    // this.initData()
  },
  created() {
  },
  methods: {
    renderResult() {
      this.timeData = this.allTimeData;
      this.isShowData = true;
    },
    formatHMStoS(value, fen) {
      if (value) {
        if (fen) {
          const ssVal = value.split(':');
          const h = parseInt(ssVal[0]);
          let m = parseInt(ssVal[1]) + parseInt(h * 60);
          let s = parseInt(ssVal[2]);
          m = m >= 10 ? m : `0${m}`;
          s = s >= 10 ? s : `0${s}`;
          const ss = `${m}:${s}`;
          return ss;
        }
        const ssVal = value.split(':');
        const h = parseInt(ssVal[0]);
        const m = parseInt(ssVal[1]);
        const s = parseInt(ssVal[2]);
        const ss = h * 60 * 60 + m * 60 + s;
        return ss;
      }
      return '00';
    },
  },
};
</script>

<style lang="scss" scoped>
 h2 {
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
.time-wrap{
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  h4{
    font-size: 20px;
    letter-spacing: 0;
    text-align: center;
    line-height: 16px;
  }
 
  .my-time{
    margin-left: 86px;
    h4{
      color: #00B1FF;
    }
  }
  .all-time{
    margin-right: 86px;
    h4{
      color: #FF9A42;
    }
  }
  .pie{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    position: relative;
    .showTime {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 28px;
    }
  }
  .my-pie{
    background: url("~@/assets/img/my_tiem_bg.png") no-repeat;
    background-size: cover;
  }
  .module-detail .el-progress{
    width: 126px;
    height: 126px;
    
  }
  .state-pie{
    background: url("~@/assets/img/state_tiem_bg.png") no-repeat;
    background-size: cover;
  }
  img{
    width: 46px;
    height: 56px;
    flex:0 0 auto;
  }
}
.module-all-time .el-progress__text{
  color: #000;
  font-size: 28px!important;
}
@media print {
  .module-all-time .el-progress--circle .el-progress__text,.module-right-rate .el-progress--circle .el-progress__text{
    width: 126px!important;
    text-align: left;
    margin-left: -30px;
  }
  .report-container .area-section .module-wrap h2 {
    margin-top: 10px;
  }
}
</style>
